<script>
import { mapGetters } from 'vuex';
import { useAlert } from 'dashboard/composables';

import InboxTeamsAPI from '../../../../api/inboxTeams';
import NextButton from 'dashboard/components-next/button/Button.vue';
import TagInput from 'dashboard/components-next/taginput/TagInput.vue';
import router from '../../../index';
import PageHeader from '../SettingsSubPageHeader.vue';

export default {
  components: {
    PageHeader,
    NextButton,
    TagInput,
  },
  data() {
    return {
      selectedTeamIds: [],
      isCreating: false,
    };
  },
  computed: {
    ...mapGetters({
      teamList: 'teams/getTeams',
    }),
    selectedTeamNames() {
      return this.selectedTeamIds.map(
        id => this.teamList.find(team => team.id === id)?.name ?? ''
      );
    },
    teamMenuItems() {
      return this.teamList
        .filter(({ id }) => !this.selectedTeamIds.includes(id))
        .map(({ id, name }) => ({
          label: name,
          value: id,
          action: 'select',
        }));
    },
  },
  mounted() {
    this.$store.dispatch('teams/get');
  },
  methods: {
    handleTeamAdd({ value }) {
      if (!this.selectedTeamIds.includes(value)) {
        this.selectedTeamIds.push(value);
      }
    },
    handleTeamRemove(index) {
      this.selectedTeamIds.splice(index, 1);
    },
    async addTeams() {
      this.isCreating = true;
      const inboxId = this.$route.params.inbox_id;

      try {
        await InboxTeamsAPI.update({
          inboxId,
          teamIds: this.selectedTeamIds,
        });
        router.replace({
          name: 'settings_inbox_finish',
          params: {
            page: 'new',
            inbox_id: this.$route.params.inbox_id,
          },
        });
      } catch (error) {
        useAlert(error.message);
      }
      this.isCreating = false;
    },
  },
};
</script>

<template>
  <div class="h-full w-full p-6 col-span-6">
    <form class="flex flex-wrap flex-col mx-0" @submit.prevent="addTeams()">
      <div class="w-full">
        <PageHeader
          :header-title="$t('INBOX_MGMT.ADD.TEAMS.TITLE')"
          :header-content="$t('INBOX_MGMT.ADD.TEAMS.DESC')"
        />
      </div>
      <div>
        <div class="w-full mb-4">
          <label>
            {{ $t('INBOX_MGMT.ADD.TEAMS.TITLE') }}
            <div
              data-testid="team-selector"
              class="rounded-xl outline outline-1 -outline-offset-1 outline-n-weak hover:outline-n-strong px-2 py-2"
            >
              <TagInput
                :model-value="selectedTeamNames"
                :placeholder="$t('INBOX_MGMT.ADD.TEAMS.PICK_TEAMS')"
                :menu-items="teamMenuItems"
                show-dropdown
                skip-label-dedup
                @add="handleTeamAdd"
                @remove="handleTeamRemove"
              />
            </div>
          </label>
        </div>
        <div class="w-full">
          <NextButton
            type="submit"
            :is-loading="isCreating"
            solid
            blue
            :label="$t('INBOX_MGMT.ADD.TEAMS.BUTTON_TEXT')"
          />
        </div>
      </div>
    </form>
  </div>
</template>
